/* tslint:disable */
/* eslint-disable */
/**
 * BloomRegistration.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    PaymentDto,
    PaymentDtoFromJSON,
    PaymentDtoToJSON,
} from '../models';

/**
 * 
 */
export class BillingApi extends runtime.BaseAPI {

    /**
     */
    async apiBillingGetRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<PaymentDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/Billing`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PaymentDtoFromJSON));
    }

    /**
     */
    async apiBillingGet(initOverrides?: RequestInit): Promise<Array<PaymentDto>> {
        const response = await this.apiBillingGetRaw(initOverrides);
        return await response.value();
    }

}
